import "./styles.scss";

import React, { useEffect, useRef, useState } from "react";

import AnimatedIntersection from "components/AnimatedIntersection";
import Heading from "components/Heading";
import SimpleCard from "components/SimpleCard";

import { getColorVariant } from "utils";

const News = ({ list }) => {
  const [isMobile, setIsMobile] = useState(false);
  const timeoutDebounce = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      clearTimeout(timeoutDebounce.current);

      timeoutDebounce.current = setTimeout(() => {
        setIsMobile(window.outerWidth < 992);
      }, 100);
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    list?.length > 0 && (
      <AnimatedIntersection
        id="news-gradient"
        title="Spokój w Głowie to specjaliści, którym możesz zaufać."
        options={{ timeProgress: 0.24, seed: 8 }}
        variant="blue-light"
      >
        <div className="main-news">
          <div className="d-lg-none">
            <Heading title="Nowości w naszej poradni" />
          </div>
          <div className="row flex-lg-row-reverse">
            <div className="col-lg-9">
              <div className="main-news__posts">
                <div className="row">
                  {list.slice(0, 4).map((item, index) => (
                    <div key={index} className="col-sm-6">
                      <SimpleCard
                        url={item.content.link}
                        image={item.image?.sourceUrl}
                        title={item.content.title}
                        description={item.content.description}
                        variant={getColorVariant(index + 1)}
                        isBorderless={!isMobile}
                        isEqual={isMobile}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="main-news__column">
                <div className="d-none d-lg-block">
                  <Heading title="Nowości w naszej poradni" />
                </div>
                <div className="main-news__shortcuts">
                  {list.map((item, index) => (
                    <SimpleCard
                      key={index}
                      url={item.content.link}
                      title={item.content.title}
                      variant={getColorVariant(index + 1)}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </AnimatedIntersection>
    )
  );
};

export default News;
